
      export const versions = {
        commit: '7d7feb842442ec80ef4df7dd4f4739d63c46fca9',
        branch: 'HEAD'
      };
